import type { PageContentItem } from '../models/page';

export function extractItemListFromContent<T extends { [key: string]: any }>(
  propName: string,
  contents: readonly PageContentItem[]
): { restContents: readonly PageContentItem[]; items: T[] } {
  const component = contents.find(
    (content) => content.componentName === propName
  );
  const restContents = contents.filter((content) => content !== component);

  const items = (component?.contents || []).map<T>((content) => ({
    ...content.props,
  }));

  return {
    restContents,
    items,
  };
}
